import { render } from "./SelectBrowseItem.vue?vue&type=template&id=252a58fa"
import script from "./SelectBrowseItem.vue?vue&type=script&lang=js"
export * from "./SelectBrowseItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__